import {Nullable} from '../../../app/TypeHelpers'
import {MeetingLink} from './MeetingLink'

export default class NewMeeting {
    name: string
    date: Nullable<string>
    startTime: Nullable<string>
    endTime: Nullable<string>
    url: Nullable<string>
    place: Nullable<string>
    memo: Nullable<string>
    contents: Nullable<string>
    attendanceReplyDeadline: Nullable<string>
    manageAttendance: string
    proxyAttendanceAvailability: Nullable<string>
    meetingAttachmentLinkList: MeetingLink[]

    constructor(
        name: string,
        date: Nullable<string>,
        startTime: Nullable<string>,
        endTime: Nullable<string>,
        url: Nullable<string>,
        place: Nullable<string>,
        memo: Nullable<string>,
        contents: Nullable<string>,
        attendanceReplyDeadline: Nullable<string>,
        manageAttendance: string,
        proxyAttendanceAvailability: Nullable<string>,
        meetingAttachmentLinkList: MeetingLink[],
    ) {
        this.name = name
        this.date = date
        this.startTime = startTime
        this.endTime = endTime
        this.url = url
        this.place = place
        this.memo = memo
        this.contents = contents
        this.attendanceReplyDeadline = attendanceReplyDeadline
        this.manageAttendance = manageAttendance
        this.proxyAttendanceAvailability = proxyAttendanceAvailability
        this.meetingAttachmentLinkList = meetingAttachmentLinkList
    }
}
